import React from 'react'
const ActionButton = React.memo(({ onClick, disabled, className, children }) => (
    <button
        onClick={onClick}
        className={`btn btn-sm ${className}`}
        disabled={disabled}
    >
        {children}
    </button>
));

const SaveConfigurationButton = ({ className, isSaving, isModified, isInitialConfiguration, showList, handleSaveConfiguration, handleShowList }) => {
    return (
        <ActionButton
            onClick={!showList ? handleShowList : handleSaveConfiguration}
            className={`${isSaving || (!isInitialConfiguration && !showList) ? 'btn-disabled' : 'btn-primary'} ${className}`}
            disabled={isSaving || (!isInitialConfiguration && !showList)}
        >
            {!showList ? `Ajouter / Supprimer` : showList && !isModified ? ' Sensibilités et dilutions' : (isSaving ? 'Enregistrement...' : 'Enregistrer')}
        </ActionButton>
    )
}

export default SaveConfigurationButton